module.exports = __webpack_public_path__ + "img/icon-email.c17b9b89.svg";